import { atom } from 'recoil';

export const aDeviceSetupNotification = atom<boolean>({ key: 'aDeviceSetupNotification', default: false });
export const aLandingPageClickedGoIn = atom<boolean>({ key: 'aLandingPageClickedGoIn', default: false });
export const aIsYoutubeVideoVisible = atom<boolean>({ key: 'aIsYoutubeVideoVisible', default: true });
